import { atom, atomFamily, selector } from 'recoil'

export const messageState = atom({
  key: 'messageCheckupLinkCheckMessageState',
  default: {
    id: undefined,
    messageType: undefined,
    isBee: undefined,
    customParams: '',
    links: { link: [], image: [] },
    showJustUnreachable: false,
    showJustBadReputation: false
  }
})

export const messageLink = atomFamily({
  key: 'messageCheckupLinkState',
  default: {
    loaded: false,
    loading: true,
    link: {},
    error: false,
    errorMessage: undefined,
    reachability: false,
    reputation: false,
    action: undefined,
    issues: []
  }
})

export const linkcheckSummaryBoxState = selector({
  key: 'messageCheckupLinkcheckSummaryBoxState',
  get: ({ get }) => {
    const { links } = get(messageState)
    const linkUrlsValue = links.link.map(({ Url }) => get(messageLink(Url)))
    const imgUrlsValue = links.image.map(({ Url }) => get(messageLink(Url)))

    const linksLoaded = linkUrlsValue.filter(({ loaded }) => loaded === true)
    const imgsLoaded = imgUrlsValue.filter(({ loaded }) => loaded === true)

    const linksDangerAction = linkUrlsValue.filter(({ action }) => action === 2)
    const goodReputationLinks = linkUrlsValue.filter(
      ({ action }) => action === 0
    )
    const badReputationLinks = linkUrlsValue.filter(({ action }) => action > 0)

    const reachableLinks = linkUrlsValue.filter(
      ({ reachability }) => reachability === true
    )
    const reachableImg = imgUrlsValue.filter(
      ({ reachability }) => reachability === true
    )
    const unreachableLinks = linkUrlsValue.filter(
      ({ reachability }) => reachability === false
    )
    const unreachableImgs = imgUrlsValue.filter(
      ({ reachability }) => reachability === false
    )

    const unreachableUrlsCount = unreachableImgs.length + unreachableLinks.length

    const areAllLinksLoaded = () => linksLoaded.length === linkUrlsValue.length
    const areAllLinksReachable = () =>
      reachableLinks.length + reachableImg.length === linksLoaded.length + imgsLoaded.length
    const areAllLinksGoodReputation = () =>
      goodReputationLinks.length === linksLoaded.length

    return {
      areAllLinksLoaded,
      areAllLinksReachable,
      areAllLinksGoodReputation,
      goodReputationLinks,
      badReputationLinks,
      reachableLinks,
      unreachableLinks,
      unreachableImgs,
      unreachableUrlsCount,
      linksDangerAction
    }
  }
})
